import { AppRolePermissions } from '../../permissions'

const MARKETING_SYSTEMS: AppRolePermissions = {
  active_assortment_view: true,
  assortment_backups_create: false,
  assortment_backups_restore: false,
  assortment_banners_edit: false,
  assortment_banners_publish: false,
  assortment_banners_view: false,
  assortment_launches_create: false,
  assortment_launches_edit: false,
  assortment_launches_publish: false,
  assortment_launches_view: false,
  assortment_materials_clean_up: false,
  assortment_materials_replace: false,
  assortment_materials_sequences_edit: false,
  assortment_materials_sync: false,
  audit_trails_view: false,
  customers_banners_view: false,
  customers_stores_view: true,
  invites_delete: false,
  invites_send: false,
  invites_view: false,
  map_viewAllAreas: true,
  materials_bcp_priced_view: false,
  materials_materials_list_view: false,
  materials_price_list_view: false,
  operations_execute: false,
  orders_all_view: true,
  orders_charts_view: true,
  orders_editQuantities: false,
  orders_flagged_view: true,
  orders_leg_release_timeout_edit: false,
  orders_payment_review_release: false,
  orders_payment_review_view: false,
  orders_uncouple: false,
  orders_release: false,
  orders_returns_view: true,
  reports_view: true,
  reports_view_ecc: true,
  reports_view_material: true,
  reports_view_misc: true,
  reports_view_operations: true,
  reports_view_order_service: true,
  reports_view_salesforce: true,
  roles_view: false,
  sox_compliance_scheduled_reports_create: false,
  sox_compliance_scheduled_reports_delete: false,
  sox_compliance_scheduled_reports_edit: false,
  sox_compliance_view: false,
  upload_allUploads_view: false,
  upload_autoDistro: true,
  upload_autoInject: true,
  upload_autoInjectDeliveryDates: true,
  upload_autoInjectRMA: true,
  upload_ediPOConfControl: true,
  upload_erpSkuSubstitution: false,
  upload_limitQuantity: true,
  upload_limitQuantityExemptions: true,
  upload_materialSpecificationConversion: false,
  upload_merchandise: false,
  upload_myUpload_view: true,
  upload_nodAddPosition: true,
  upload_onHandInventoryDuns: true,
  upload_onHandInventoryPartial: true,
  upload_onHandInventoryUOM: true,
  upload_routeStopSequence: true,
  upload_skuUpcOverride: false,
  upload_suspendOrderSubmission: false,
  upload_taxRate: true,
  users_manageAdmins: false,
  users_managePermissionsOverrides: false,
  users_manageAccess: false,
  users_manageTerritoriesOverrides: false,
  users_view: false,
}

export default MARKETING_SYSTEMS
